angular.module('picmonicng').component('homeGroupbuy', {
  templateUrl: '/templates/app/components/home-groupbuy/home-groupbuy.html',
  bindings: {
    settings: '=',
  },
  controller: [
    '$scope',
    'GroupBuyService',
    'UserService',
    'toaster',
    'User',
    '$modal',
    function ($scope, GroupBuyService, UserService, toaster, User, $modal) {
      var ctrl = this;
      ctrl.GroupBuyService = GroupBuyService;
      ctrl.UserService = UserService;
      GroupBuyService.init();

      GroupBuyService.group_buy.$promise.then(function () {
        if (GroupBuyService.group_buy.time_left) {
          User.last_gb_order().$promise.then(function (order) {
            ctrl.goalHit =
              GroupBuyService.group_buy.users &&
              GroupBuyService.group_buy.users.length >= GroupBuyService.group_buy.goal;
            if (ctrl.goalHit) {
              ctrl.savingsText =
                'Your Savings: <strong class="pls-green">$' +
                ((order.order.original_amount * GroupBuyService.group_buy.discount_after_goal) / 100).toFixed(2) +
                '</strong>';
            } else {
              ctrl.savingsText =
                'Your Potential Refund: <strong class="pls-green">$' +
                (
                  (order.order.original_amount *
                    (GroupBuyService.group_buy.discount_after_goal - GroupBuyService.group_buy.discount_before_goal)) /
                  100
                ).toFixed(2) +
                '</strong>';
            }
          });
        }
      });

      ctrl.copy = function () {
        toaster.success('Copied', 'URL has been copied to the clipboard.');
      };

      ctrl.days = function () {
        var days = Math.floor(GroupBuyService.group_buy.time_left / (60 * 60 * 24));

        return days > 0 ? days + 'd ' : '';
      };

      ctrl.hours = function () {
        var hours = Math.floor(GroupBuyService.group_buy.time_left / (60 * 60)) % 24;

        if (hours < 10) {
          hours = '0' + hours;
        }
        return hours + 'h ';
      };

      ctrl.minutes = function () {
        var minutes = Math.floor(GroupBuyService.group_buy.time_left / 60) % 60;

        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        return minutes + 'm ';
      };

      ctrl.seconds = function () {
        var seconds = Math.floor(GroupBuyService.group_buy.time_left) % 60;

        if (seconds < 10) {
          seconds = '0' + seconds;
        }
        return seconds + 's';
      };

      ctrl.joiners = function () {
        $modal.open({
          templateUrl: '/templates/app/components/home-groupbuy/home-groupbuy-joiners.html',
          controller: [
            '$scope',
            function ($scope) {
              $scope.GroupBuyService = GroupBuyService;
            },
          ],
        });
      };
    },
  ],
});
